module.exports = __webpack_public_path__ + "img/img.787e9bf4.png";